const state = {
    payment: {},
    payments: [],
}
const actions = {
    showPayments: (context, date = null) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/payments${date ? '?date=' + date : ''}`).then(response => {
                context.commit('SHOW_PAYMENTS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showPayment: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/payments/${id}`).then(response => {
                context.commit('SHOW_PAYMENT', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storePayment: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/payments`, payload).then(response => {
                context.commit('STORE_PAYMENT', response.data)
                context.dispatch('showPayments')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePayment: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/payments/${payload.id}`, payload).then(response => {
                context.dispatch('showPayments')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyPayment: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/payments/${id}`).then(response => {
                context.dispatch('showPayments')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_PAYMENT: (state, payload) => {
        state.payment = payload
    },
    SHOW_PAYMENTS: (state, payload) => {
        state.payments = payload
    },
    STORE_PAYMENT: (state, payload) => {
        state.payment = payload
    }
}
const getters = {
    payment: state => {
        return state.payment
    },
    payments: state => {
        return state.payments
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}